import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    pageTitleWrapper: {
      marginBottom: "32px",
    },
    headerWrapper: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
  };
});
